import { ListItem, Button, ListItemButton, ListItemIcon, Box, ListItemAvatar, ListItemText, Collapse, Grid, Typography, Divider, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState, useCallback, useMemo, useContext } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CandidateImage } from "./candidate-image";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ICandidate } from "../domain/candidate";
import { LightBox } from "./light-box";
import { CANDIDATE_DISPLAY_FORMAT } from "../domain/ballot-api";

export interface CandidateRowProps {
    candidate: ICandidate;
    onClick: (c: ICandidate) => void;
    icon?: JSX.Element;
    display_format?: CANDIDATE_DISPLAY_FORMAT
}
export const CandidateRow = (props: CandidateRowProps) => {
    const { display_format } = props;
    if (display_format === CANDIDATE_DISPLAY_FORMAT.IMAGE_PRIORITY) {
        return <CandidateRowImage {...props} />
    }
    return <CandidateRowLabel {...props} />
}


export const CandidateRowLabel = ({
    candidate,
    onClick,
    icon
}: CandidateRowProps) => {
    const [open, setOpen] = useState(false);

    const handleClick = useCallback(() => {
        onClick(candidate);
    }, [candidate, onClick]);
    const handleExpand = useCallback(() => setOpen((o) => !o), [setOpen]);
    return (
        <>
            <ListItem
                sx={{
                    cursor: "pointer",
                    padding: 0,
                    ":hover": {
                        background: "#EEE",
                    },
                }}
                secondaryAction={
                    <StatementButton candidate={candidate} onClick={handleExpand} open={open} />
                }
            >
                <ListItemButton onClick={handleClick}>
                    <ListItemIcon>
                        {icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={candidate.label}
                        secondary={<span style={{ whiteSpace: "pre-line" }}>{candidate.tag_line}</span>}
                    />
                </ListItemButton>
            </ListItem>
            <Statement candidate={candidate} open={open} />

            <Divider component="li" />
        </>
    );
};


export const CandidateRowImage = ({
    candidate,
    onClick,
    icon
}: CandidateRowProps) => {
    const [disableRipple, setDisableRipple] = useState(false);
    const [open, setOpen] = useState(false);
    const handleClick = useCallback(() => {
        setDisableRipple(false);
        onClick(candidate);
    }, [candidate, onClick]);
    const handleExpand = useCallback(() => setOpen((o) => !o), [setOpen]);
    const handleLightBox = useCallback((open: boolean) => {
        setDisableRipple(open)
    }, [setDisableRipple])

    return (
        <>
            <Divider component="li" />
            <ListItem
                sx={{
                    cursor: "pointer",
                    padding: 0,
                    ":hover": {
                        background: "#EEE",
                    },
                    pr: 0

                }}

                secondaryAction={
                    <StatementButton candidate={candidate} onClick={handleExpand} open={open} />
                }
            >
                <ListItemButton onClick={handleClick} sx={{
                    flexDirection: 'column'
                }} disableRipple={disableRipple}>
                    <Grid2 container width="100%">
                        <Grid2 sm={6} xs={12}>
                            <Box sx={{ display: 'flex', width: '100%' }}>

                                <ListItemIcon>
                                    {/* <NumberInput index={i} value={mapping[c.id]} /> */}
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={candidate.label} secondary={candidate.tag_line} />
                            </Box>
                        </Grid2>
                        <Grid2 sm={6} xs={12}>
                            <Box width="100%" height="150px" justifyItems="center" mb={1} mt={2}>

                                <Box maxWidth={400} height="150px">
                                    <ListItemAvatar sx={{ maxWidth: "100%", height: "100%" }}>
                                        <CandidateImage candidate={candidate} />
                                    </ListItemAvatar>
                                </Box>
                            </Box>
                        </Grid2>
                    </Grid2>
                </ListItemButton>


            </ListItem>

            {open ? (
                <Statement open={open} candidate={candidate} />
            ) : null}
        </>
    );
};


interface StatementProps {
    candidate: ICandidate;
    onClick?: () => void;
    open: boolean;
}
const StatementButton = ({ candidate, onClick, open }: StatementProps) => {
    const { statement, image_lg_url, image_sm_url } = candidate;
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up("md"));

    if (!statement && !image_lg_url && !image_sm_url) {
        return null;
    }

    if (!md) {
        return (<IconButton
            onClick={onClick}
        >
            <ExpandMoreIcon
                fontSize="large"
                sx={{
                    transition: "transform ease 0.5s",
                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                }}
            />
        </IconButton>)
    }

    return (<Button
        endIcon={
            <ExpandMoreIcon
                sx={{
                    transition: "transform ease 0.5s",
                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                }}
            />
        }
        onClick={onClick}
        sx={{ p: 1.7, position: 'relative', right: -16, borderRadius: 0 }}
    >
        <Typography sx={{ display: { xs: 'none', sm: 'inline' } }}>Statement</Typography>
    </Button>)
}


interface StatementProps {
    candidate: ICandidate;
    open: boolean;
}
const Statement = ({ candidate, open }: StatementProps) => {
    const { image_lg_url, image_sm_url } = candidate;

    const content = useMemo(() => {
        if (!image_lg_url && !image_sm_url) {
            return (

                <Typography sx={{ whiteSpace: "pre-line" }}>{candidate.statement}</Typography>
            )
        }

        return (
            <Box sx={{}}>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                    <CandidateImage candidate={candidate} />
                    {candidate.statement}</Typography>
            </Box>
        )
    }, []);

    return <Collapse in={open} timeout="auto" unmountOnExit sx={{ maxHeight: "400px", overflowY: 'auto', pl: 4, pr: 1, pt: 2, pb: 4 }}>
        {content}
    </Collapse>
}